import { serialize, deserialize } from '~/plugins/ag-grid/mixins/table-linkable/table-state-serializer'

export default {
  inject: {
    tableColumnsState: {
      default: null
    }
  },

  data: () => ({
    initialState: ''
  }),

  methods: {
    _setupColumnState () {
      // do not init the api if page does not implement columnsState data
      if (this.columnsState === null) return

      this.gridOptions.api.addEventListener('firstDataRendered', this._tableColumnsState_onFirstDataRendered)
      this.gridOptions.api.addEventListener('sortChanged', this._tableColumnsState_onColumnStateChange)
      this.gridOptions.api.addEventListener('columnMoved', this._tableColumnsState_onColumnStateChange)
      this.gridOptions.api.addEventListener('columnVisible', this._tableColumnsState_onColumnStateChange)
      this.gridOptions.api.addEventListener('columnRowGroupChanged', this._tableColumnsState_onColumnStateChange)
    },
    _tableColumnsState_deserialize (payload) {
      if (!payload.length) return []
      const columns = this.gridOptions.api.getColumnDefs().flatMap(col => col.children ?? col)
      return deserialize(payload, columns)
    },
    _tableColumnsState_serialize (payload) {
      const columns = this.gridOptions.api.getColumnDefs().flatMap(col => col.children ?? col)
      return serialize(payload, columns)
    },
    _tableColumnsState_onFirstDataRendered () {
      this.initialState = this._tableColumnsState_serialize(this.gridOptions.api.getColumnState())
      this.gridOptions.api.applyColumnState({ state: this._tableColumnsState_deserialize(this.tableColumnsState.state), applyOrder: true })
    },
    _tableColumnsState_onColumnStateChange () {
      if (this.loading) return

      const currentState = this._tableColumnsState_serialize(this.gridOptions.api.getColumnState())

      // if a change is triggered and new state equals table first initial state
      // means it was reset programmatically, we should reset, this way url gets
      // back to original state
      this.tableColumnsState.state = currentState === this.initialState ? '' : currentState
    }
  }
}
